import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { ReportingDashboardPage } from '@/pages/reporting/dashboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/reporting/')({
  beforeLoad: () => {
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.viewReporting });
  },
  component: ReportingDashboardPage,
});
